import { ImageUrlConcat, UrlConcat } from './type'
import concat from 'lodash/concat'
import config from '../config'

export const urlConcat: UrlConcat = (paths) => {
  const doubleSlashsPlacholder = '{{_DOUBLE_SLASHS_}}'
  if (paths.length === 0) return null
  const serializeUrl = paths.map((path) => {
    return path ? path.replace('://', doubleSlashsPlacholder).split('/') : null
  })
  const concatArraySector = concat(...serializeUrl).filter((sector) => sector)
  if (concatArraySector.length === 0) return null
  return concatArraySector.join('/').replace(doubleSlashsPlacholder, '://')
}

export const imageUrlConcat: ImageUrlConcat = (imagePath: string) => {
  const baseUrl = config('assets.baseUrl.image')
  if (!imagePath) return null
  return urlConcat([baseUrl, imagePath])
}
